import { useTranslation } from 'react-i18next';
import SearchableSelect from '../searchableSelect/searchableSelect';
import { useMatterRequestCustomerSelect } from './useMatterRequestCustomerSelect';

interface MatterRequestCustomerSelectProps {
  onOpenPicker: () => void;
}

/**
 * Its own component so the customer list is only fetched where the field is rendered. It renders
 * the trigger button directly, which lookup siblings like `LookupClearButton` rely on.
 */
const MatterRequestCustomerSelect = ({
  onOpenPicker,
}: Readonly<MatterRequestCustomerSelectProps>) => {
  const { t } = useTranslation();
  const select = useMatterRequestCustomerSelect();

  return (
    <SearchableSelect
      {...select}
      ariaLabel={t('customer:customer')}
      placeholder={t('matterRequest:selectCustomer')}
      searchPlaceholder={t('customer:search')}
      onSearchIconClick={onOpenPicker}
      data-field="customer"
      data-testid="add-customer-button"
    />
  );
};

export default MatterRequestCustomerSelect;
